// TODO: Migrate My Plans to Microapp
import {DOCUMENT} from '@angular/common';
import {Injectable, OnDestroy, NgZone, Inject} from '@angular/core';
import {apiUrlMap} from '@ox/config';
import {ApiDataService, Header, TrackingService} from '@ox/data';
import {Copy, RecommendedOffers, UpdatePlan, UserSubscriptions} from '@ox/typings';
import {AppConfigService} from '@ox/utils';
import {Observable, catchError, map} from 'rxjs';

@Injectable()
export class MyPlansUnifiedService implements OnDestroy {
  public brand = this.appConfig.bml.brand;
  public market = this.appConfig.bml.market;

  private cache = new Map<string, Copy>();

  globalNav: HTMLElement | null;
  globalFooter: HTMLElement | null;

  constructor(
    private appConfig: AppConfigService,
    private api: ApiDataService,
    private trackingService: TrackingService,
    private ngZone: NgZone,
    @Inject(DOCUMENT) private document: Document
  ) {}

  getMyPlans(vin: string) {
    const _header: Header = {vin: vin};
    const _headers: Header[] = [];
    _headers.push(_header);
    return this.api
      .post<UserSubscriptions>(
        apiUrlMap.myPlansUnified.subscriptions,
        undefined,
        undefined,
        undefined,
        undefined,
        _headers
      )
      .pipe(
        map((response) => {
          if (response) {
            return response;
          }
          throw new Error('No Data');
        }),
        catchError((error) => {
          let errorString: string;
          if (error === 'OC-BFF-SUB001') {
            errorString = 'BFF.Review.API.Failure';
          } else if (error === 'OC-BFF-SUB002') {
            errorString = 'OC-BFF-SUB002';
          } else {
            errorString =
              'Subscription with payment details API call failure - Unable to retrieve data from BFF';
          }
          this.trackingService.trackEvent('event25', errorString);
          throw new Error();
        })
      );
  }

  getUpdatePlans(vin: string) {
    const _headers: Header[] = [
      {
        type: 'FEATURED,BYO'
      },
      {
        vin: vin
      }
    ];

    return this.api
      .get<UpdatePlan>(
        apiUrlMap.myPlansUnified.updatePlans,
        undefined,
        undefined,
        undefined,
        undefined,
        _headers
      )
      .pipe(
        map((response) => {
          if (response) {
            return response && response.data;
          }
          throw new Error('No Data');
        }),
        catchError((error) => {
          throw new Error(error);
        })
      );
  }

  getRecommendedOffers(vin: string): Observable<RecommendedOffers> {
    const _headers: Header[] = [];
    _headers.push({vin: vin});
    return this.api.get<RecommendedOffers>(
        apiUrlMap.myPlansUnified.recommended, 
        undefined, 
        undefined, 
        undefined, 
        undefined,
        _headers
      )
      .pipe(
        map((response) => {
          if (response) {
            return response.data;
          }
          throw new Error('No Recommended Offers');
        }),
        catchError((error) => {
          throw new Error();
        })
      );
  }

  ngOnDestroy() {
    this.cache.clear();
  }

  private getGlobalHeaderFooter() {
    if (!this.globalNav) {
      this.globalNav = this.document.getElementById('gbGlobalNav');
      this.globalFooter = this.document.getElementById('gbGlobalFooter');
    }
  }

  hideHeaderFooter() {
    this.ngZone.runOutsideAngular(() => {
      this.getGlobalHeaderFooter();
      this.globalNav?.setAttribute('hide', '');
      this.globalFooter?.setAttribute('style', 'display:none');
    });
  }

  showHeaderFooter() {
    this.ngZone.runOutsideAngular(() => {
      this.getGlobalHeaderFooter();
      this.globalNav?.removeAttribute('hide');
      this.globalFooter?.setAttribute('style', 'display:""');
    });
  }
}
